<div style="font-size: small;">
    <div class="alert-success me-4" *ngIf="successMessageAlert">
        <img style="margin-right: 1em;" src="../assets/images/checkCircle.svg" alt="successMsg">
        <span>{{successMsg}}</span>    
    </div>
    <div class="alert-failure me-4" *ngIf="failureMessageAlert">
        <img style="margin-right: 1em;" src="../assets/images/errCircle.png" alt="failureMsg">
        <span>{{failureMsg}}</span>    
    </div><br>
    <div>
        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class="text-left col-form-label label-tmna steps">STEP 1:</span>
            </div>
            <div class="col-md-2 ml-2 ml-3">
                <span class="text-left col-form-label label-tmna required">Enter the Name of the New Report Period:</span>
            </div>
           
            <div class="col-md-3">
                <input type="text" [(ngModel)]="name" (input)="validateName($event)" class="text form-control input-tmna ms-2" placeholder="Enter the Report Period Name" minlength="2" maxlength="50">
                <div *ngIf="(!name && submitted) || (errorName && submitted)" class="label-tmna ms-2">
                    <span style="color: red;">*Please enter a valid name (must start with a letter, minimum 2 and maximum 50 characters. Can contain only letters, numbers, and spaces).</span>
                </div>
            </div>
        </div><br>

    <div class="form-group">
        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class=" text-left col-form-label label-tmna steps">STEP 2:</span>
            </div>
            <div class="col-md-2 ml-2 ml-3">
                <span class=" text-left col-form-label label-tmna required">Select a Date for the New Report Period:</span>
            </div>
            <div class="col-md-3">
                <input type="date" (change)="dateChange($event)" (input)="validateDate($event)" [min]="today" class="text form-control input-tmna ms-2" [(ngModel)]="dateperiod" onkeydown="return false;" (click)="newReportDatePicker($event)"> 
                <div *ngIf="!dateperiod && submitted" style="color: red;" class="label-tmna ms-2">*Please select a date for the New Report Period.</div>
                <div *ngIf="errorDate && submitted" style="color: red;" class="label-tmna ms-2">*Date cannot be in the past.</div>
            </div>
        </div>
    </div><br>

    <div class="form-group">
        <div class="row">
            <div class="col-md-1 mgn-1 mt-2">
                <span class="text-left col-form-label label-tmna steps">STEP 3:</span>
            </div>
            <div class="col-md-3 ml-3">
                <span class=" text-left col-form-label label-tmna">
                    <button (click)="createnewReportPeriod()" class="closeButton" style="width: fit-content;">
                        Create New Report Period
                    </button>
                </span>
            </div>
        </div>
    </div><br>

    <div class="form-group">
        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class=" text-left col-form-label label-tmna steps">STEP 4:</span>
            </div>
            <div class="col-md-2 ml-3">
                <span class=" text-left col-form-label label-tmna required">DMH Approver Email IDs:</span>
            </div>
            <div class="col-md-3">
                <input type="email" [(ngModel)]="emailIds" class="text form-control input-tmna ms-2" placeholder="Enter DMH Approver Email IDs">
                <div *ngIf="emailErrorCheck" style="color: red;" class="label-tmna ms-2">*Please enter a valid email.</div>
                <div *ngIf="requiredEmail" style="color: red;" class="label-tmna ms-2">*Required</div>
            </div>
        </div>
        
        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class="text-left">&nbsp;</span>
            </div>
            <div class="col-md-2 ml-3">
                <span class=" text-left col-form-label">&nbsp;</span>
            </div>
            <div class="col-md-5 m-2 label-tmna">
                Union Requests from DMH go to these email Ids for approval. If you have multiple Ids they should be separated by ','.
            </div>
        </div><br>

        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class="text-left col-form-label label-tmna steps">STEP 5:</span>
            </div>
            <div class="col-md-2 ml-3">
                <span class=" text-left col-form-label label-tmna required">Supplier Union Contingency Path:</span>
            </div>
            <div class="col-md-5">
                <span class="text-left label-tmna">
                    <input style="height: 34px;" placeholder="Enter Supplier union contingency path" type="url" [(ngModel)]="contingencyPath" class="text form-control input-tmna ms-2">
                    <div *ngIf="urlErrorContPath" style="color: red;" class="label-tmna ms-2">*Please enter a valid URL.</div>
                    <div *ngIf="requiredContPath" style="color: red;" class="label-tmna ms-2">*Required</div>
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class="text-left">&nbsp;</span>
            </div>
            <div class="col-md-2 ml-3">
                <span class=" text-left col-form-label">&nbsp;</span>
            </div>
            <div class="col-md-5 m-2 label-tmna">
                This will update the union contingency path on the Home page.
            </div>
        </div>
        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class="text-left">&nbsp;</span>
            </div>
            <div class="col-md-2 ml-3">
                <span class=" text-left col-form-label">&nbsp;</span>
            </div>
            <div class="col-md-5 ms-2">
                <a id="contingency" class="a-tag label-tmna" (click)="onpathClick('contingency')">Supplier union contingency plan</a>
           </div>
        </div><br>


        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class="text-left col-form-label label-tmna steps">STEP 6:</span>
            </div>
            <div class="col-md-2 ml-3">
                <span class=" text-left col-form-label label-tmna">FAQs Path:</span>
            </div>
            <div class="col-md-3">
                <span class="text-left label-tmna">
                    <input style="height: 34px;" placeholder="Enter FAQs path" type="url" [(ngModel)]="faqPath" class="text form-control input-tmna ms-2">
                    <div *ngIf="urlErrorFaqPath" style="color: red;" class="label-tmna ms-2">*Please enter a valid URL.</div>
                </span>
            </div>
            
        </div>
        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class="text-left">&nbsp;</span>
            </div>
            <div class="col-md-2 ml-3">
                <span class=" text-left col-form-label">&nbsp;</span>
            </div>
            <div class="col-md-5 label-tmna m-2">
                This will update the FAQs link.
            </div>
        </div>
        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class="text-left">&nbsp;</span>
            </div>
            <div class="col-md-2 ml-3">
                <span class=" text-left col-form-label">&nbsp;</span>
            </div>
            <div class="col-md-5 ms-2">
                <a id="faq" class="a-tag label-tmna" (click)="onpathClick('faq')">Frequently asked questions (FAQs)</a>
           </div>
        </div>
        <div class="row">
            <div class="col-md-1 mgn-1">
                <span class=" text-left col-form-label">&nbsp;</span>
            </div>
            <div class="col-md-2 ml-3">
                <button (click)="updatePathDetails()" class="closeButton" style="width: fit-content;">
                    Update
                </button>
            </div>
        </div><br>
    </div>
</div>